"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dissocIn = void 0;
function dissocIn(pathOrObj, pathOrObj2) {
    if (pathOrObj2 === undefined) {
        return function curriedDissoc(obj) {
            return dissocIn(obj, pathOrObj);
        };
    }
    else {
        const [f, ...path] = pathOrObj2;
        const obj = pathOrObj;
        const k = f;
        // we couldn't get to the terminal point
        if (!(k in obj))
            return obj;
        if (!path.length) {
            // we've finally got to the terminal point
            const _a = obj, _b = k, _ = _a[_b], withoutK = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return withoutK;
        }
        ;
        // keep descending
        return Object.assign(Object.assign({}, obj), { [k]: dissocIn(obj[k], path) });
    }
}
exports.dissocIn = dissocIn;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzc29jSW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGlzc29jSW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFjQSxTQUFnQixRQUFRLENBQUMsU0FBYyxFQUFFLFVBQWdCO0lBQ3JELElBQUksVUFBVSxLQUFLLFNBQVMsRUFBRTtRQUMxQixPQUFPLFNBQVMsYUFBYSxDQUFDLEdBQVE7WUFDbEMsT0FBTyxRQUFRLENBQUMsR0FBRyxFQUFFLFNBQVMsQ0FBQyxDQUFDO1FBQ3BDLENBQUMsQ0FBQTtLQUNKO1NBQU07UUFDSCxNQUFNLENBQUMsQ0FBQyxFQUFFLEdBQUcsSUFBSSxDQUFDLEdBQUcsVUFBVSxDQUFDO1FBQ2hDLE1BQU0sR0FBRyxHQUFHLFNBQVMsQ0FBQztRQUV0QixNQUFNLENBQUMsR0FBUSxDQUFDLENBQUM7UUFDakIsd0NBQXdDO1FBQ3hDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxHQUFHLENBQUM7WUFBRSxPQUFPLEdBQUcsQ0FBQztRQUU1QixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRTtZQUNkLDBDQUEwQztZQUMxQyxNQUFnQyxLQUFBLEdBQUcsRUFBM0IsS0FBQyxDQUFFLEVBQUUsQ0FBQyxTQUFBLEVBQUssUUFBUSxjQUFyQix1Q0FBdUIsQ0FBTSxDQUFDO1lBQ3BDLE9BQU8sUUFBUSxDQUFDO1NBQ25CO1FBQUEsQ0FBQztRQUVGLGtCQUFrQjtRQUNsQixPQUFPLGdDQUNBLEdBQUcsS0FDTixDQUFDLENBQUMsQ0FBQyxFQUFFLFFBQVEsQ0FBRSxHQUFXLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLEdBQ2hDLENBQUM7S0FDWjtBQUNMLENBQUM7QUF6QkQsNEJBeUJDIn0=